import { Price } from "~/common/Store/models/ProductListing";
import { User } from "~/common/Store/models/User";
import itemHasMapStyle from "../itemHasMapStyle";

interface Product {
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  price: Price;
}

export default (product: Product, user: User): boolean => {
  const {
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers,
  } = product;

  const { displaySalePrice, displayMinimumAdvertisedPrice } = price;

  const hasMapStyle = itemHasMapStyle(price, displaySalePrice);

  const platPlusUserQualifiedForMapPricing =
    (user.hasWebPlus || user.platinum.enabled) &&
    (showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers);

  return (
    hasMapStyle &&
    displayMinimumAdvertisedPrice &&
    ((showBelowMinimumAdvertisedPriceForLoggedInCustomers && user.registered) ||
      platPlusUserQualifiedForMapPricing)
  );
};
